export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'https://veth-admin.vercel.app';

export const sendAutoEmail = async ({ name, email, subject, message }) => {
  const res = await fetch(`${ADMIN_API_URL}/api/sendEmail`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, subject, message }),
  });
  if (!res.ok) throw new Error('Email send failed');
  return res.json();
};

export const SUPPORT_AUTO_REPLY = (name) =>
  `Hi there,

Thank you for reaching out to Veth Interiors! This is an automated confirmation to let you know that we have safely received your message.

Our Response Time: We typically respond to all inquiries within 2 to 4 business hours.
Operating Hours: Monday – Friday, 9:00 AM to 5:00 PM.

While you wait, here are a few quick resources:
- Track delivery via account dashboard
- Visit FAQ page for shipping and return policies

Thank you for shopping with us!

Best regards,
The Veth Interiors Support Team`;

export const TECHNICAL_AUTO_REPLY = (name) =>
  `Hi there,

Thank you for alerting us to a technical issue on Veth Interiors. This inbox is monitored directly by our Website & Digital Operations team.

We are investigating the glitch to ensure your shopping experience remains secure and seamless.

Please reply with:
- Device type (Mobile or Desktop)
- Screenshot of issue

We aim to resolve core website bugs within 2 to 12 hours.

Best regards,
Mene Goi
Website & Digital Operations Manager`;

export const isTechnicalSubject = (subject) => {
  const s = (subject || '').toLowerCase();
  return s.includes('technical') || s.includes('bug') || s.includes('website') || s.includes('glitch');
};
